import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[4],
    textAlign: "center",
    width: "100%",
    "@media (max-width: 480px)": {
      display: "none",
    },
  },
  text: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
  },
  link: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    textDecorationLine: "underline",
  },
});
